const onboardFilters = (state = {}, action) => {
  switch (action.type) {
  case 'SET_FILTER_ONBOARD_DATA':
    return action.payload;
  case 'ADD_FILTER_ONBOARD_DATA':
    return { ...state, pages: action.payload };
  default:
    return state;
  }
};

export default onboardFilters;
